import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { Dashlet } from './components/dashlet/component';
import { SearchText } from './components/search/component';
import { MaterialModule } from 'src/app/material.module';
import { TimeFilter } from './components/time-filter/component';
import { ProductTable } from './components/product-table/component';
import { ListingOffer } from './components/listing-offer/component';
import { StartEndDatePicker } from './components/start-end-date-picker/component';
import { AddFiles } from './components/add-files/component';

@NgModule({
  imports: [MaterialModule],
  declarations: [SearchText, Dashlet, TimeFilter, ProductTable, ListingOffer, StartEndDatePicker, AddFiles],
  exports: [SearchText, Dashlet, TimeFilter, ProductTable, ListingOffer, StartEndDatePicker, AddFiles],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class DirectivesModule {}
